import { FC } from 'react';
import { LoadingGiftCards } from 'Components';
import './Loading.scss';
import { useLocalization } from 'Hooks';

type LoadingProps = {};

const Loading: FC<LoadingProps> = () => {
  const localization = useLocalization();
  return (
    <div
     id="loading"
     role="status"
     aria-live='polite'
     aria-label= {localization?.web_loading_label ?? 'Yükleniyor'} // cms loading key eklenebilir.
    >
      <LoadingGiftCards />
    </div>
  );
};

export default Loading;
